export const memberIntegral = {
  INTEGRAL_RULE: 'n.809.2016.0', // 积分说明
  INTEGRAL_DETAIL: 'n.809.2017.0', // 跳转积分详情按钮
  EXCHANGE_COUPON: 'n.809.2018.0', // 兑换优惠券按钮
  EXCHANGE_GOODS: 'n.809.6780.0', // 积分兑换商品按钮点击
  EXCHANGE_GOOD_GOODS: 'n.809.10720.0', // 积分换好物
  TASK_RECEIVE_CLICK: 'n.809.8142.0', // 点击领取任务
  EXCHANGE_LIST: 'n.809.10717.0',
  TASK_GO_ORDER: 'n.809.7218.0', // 任务去下单按钮
  TASK_EXCHANGE_BTN: 'n.809.7219.0', // 任务立即兑换按钮
  TASK_POSITION_GO_ORDER: 'n.809.7220.0', // 任务广告位去下单
  EXCHANGE_DEITY_COUPON: 'n.809.7221.0', // 兑换神券按钮
  GO_MEMBER: 'n.809.7222.0', // 查看会员主页
  SIGN_IN_BTN: 'n.809.8260.0', // 积分签到按钮
  MODEL_SIGN_IN_CLICK: 'n.809.8360.0', // 积分签到弹窗按钮
  MODEL_SKIP_CLICK: 'n.809.8361.0', // 签到弹窗跳转点击
  INTEGRAL_DETAIL_RULE: 'n.416.1475.0' // 福利中心-积分规则,
}
